import { EDepositType, IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  type: EDepositType.DEPOSIT,
  sum: '',
  clientUUID: null,
  method: null,
  promoCode: null,
  card_sum: '',
  cash_sum: '',
  comment: '',
};
